module.exports = __webpack_public_path__ + "img/button-HYG-single.bf328edb.svg";